/**
 * Normalize a populated User ref or raw ObjectId for comparisons.
 * Handles `{ _id }`, `{ id }`, JWT-style user objects, and raw ObjectId strings.
 */
export function getUserId(ref) {
  if (ref == null) return null;
  if (typeof ref === "object") return ref._id ?? ref.id ?? null;
  return ref;
}
